/**
 * Responses the screen has already explained, and which must therefore not raise
 * a modal on top of that explanation.
 *
 * A failed request almost always deserves one: saying nothing leaves someone
 * believing their save went through. These are the exceptions, and each one is
 * only here because some screen carries a message saying what happened and what
 * to do about it.
 *
 * `mail_connection_failed` — a mailbox whose account the provider no longer
 * accepts answers 503 by design. Every mail screen shows the banner that says
 * the emails are safe and offers the reconnection; "Service Unavailable" over it
 * adds nothing and hides the button.
 */
const EXPLAINED_ON_SCREEN = ['mail_connection_failed'];

/**
 * @param {object|null|undefined} response  The axios response body holder.
 * @returns {boolean}
 */
export function isExplainedOnScreen(response) {
    return EXPLAINED_ON_SCREEN.includes(response?.data?.error);
}
